<template>
  <div class="container page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty
          v-if="list.length === 0"
          :description="$t('withdraw.empty_data')"
        />
        <div v-else class="record-card" v-for="(item, index) in list" :key="index">
          <div class="record-header">
            <div class="record-title">
              <div class="lottery-name">{{ item.name }}</div>
              <div class="period-number">{{ item.expect }}</div>
            </div>
            <div
              class="status-tag"
              :class="{
                settled: Number(item.status) === 1,
                pending: Number(item.status) !== 1,
              }"
            >
              {{ item.status_text }}
            </div>
          </div>

          <div class="dice-panel">
            <div class="play-image-wrap">
              <img
                v-if="hasResultImage(item)"
                class="play-img"
                :src="getResultImage(item)"
                :alt="getResultImageLabel(item)"
              />
              <div v-else class="play-placeholder">
                {{ getResultImageLabel(item) }}
              </div>
              <div class="play-name">{{ getResultImageLabel(item) }}</div>
            </div>
            <div class="result-tags">
              <span class="result-tag">{{ getSumText(item) }}</span>
              <span class="result-tag">{{ getSizeText(item) }}</span>
              <span class="result-tag">{{ getParityText(item) }}</span>
            </div>
          </div>

          <div class="meta-grid">
            <div class="meta-item">
              <span class="meta-label">{{ $t("reservation.money") }}</span>
              <span class="meta-value">{{ item.money }}</span>
            </div>
            <div class="meta-item">
              <span class="meta-label">{{ $t("reservation.task_list") }}</span>
              <span class="meta-value">{{ item.type_label || item.type }}</span>
            </div>
            <div class="meta-item">
              <span class="meta-label">{{ item.win_text }}</span>
              <span
                class="meta-value"
                :class="{
                  profit: Number(item.is_win) === 1,
                  loss: Number(item.is_win) === 2,
                }"
              >
                {{ formatProfit(item) }}
              </span>
            </div>
          </div>

          <div class="time-row">
            <span class="time-label">{{ $t("reservation.order_time") }}</span>
            <span class="time-value">{{ item.create_time }}</span>
          </div>
          <div class="time-row">
            <span class="time-label">{{ $t("reservation.settle_time") }}</span>
            <span class="time-value">{{ item.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.getUserGameList();
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    hasResultImage(item) {
      if (Number(item.status) !== 1) {
        return false;
      }
      const type = String(item.type_label || item.type || "").trim();
      return (
        type === "玫瑰" ||
        type === "百合" ||
        type === "烟花" ||
        type === "气球" ||
        type === this.$t("reservation.big") ||
        type === this.$t("reservation.small") ||
        type === this.$t("reservation.double") ||
        type === this.$t("reservation.single")
      );
    },
    getResultImage(item) {
      const type = String(item.type_label || item.type || "").trim();
      if (type === "玫瑰" || type === this.$t("reservation.big")) {
        return require("@/assets/bc-img/meigui.png");
      }
      if (type === "百合" || type === this.$t("reservation.small")) {
        return require("@/assets/bc-img/baihe.png");
      }
      if (type === "烟花" || type === this.$t("reservation.double")) {
        return require("@/assets/bc-img/yanhua.png");
      }
      if (type === "气球" || type === this.$t("reservation.single")) {
        return require("@/assets/bc-img/qiqiu.png");
      }
      return "";
    },
    getResultImageLabel(item) {
      if (Number(item.status) !== 1) {
        return item.status_text;
      }
      return item.type_label || item.type || item.status_text;
    },
    getSum(item) {
      if (!Array.isArray(item.opencode) || item.opencode.length < 3) return 0;
      return (
        Number(item.opencode[0]) +
        Number(item.opencode[1]) +
        Number(item.opencode[2])
      );
    },
    getSumText(item) {
      if (Number(item.status) !== 1) return item.status_text;
      return `${this.getSum(item)}`;
    },
    getSizeText(item) {
      if (Number(item.status) !== 1) return item.status_text;
      const sum = this.getSum(item);
      return sum >= 11 && sum <= 18
        ? this.$t("reservation.big")
        : this.$t("reservation.small");
    },
    getParityText(item) {
      if (Number(item.status) !== 1) return item.status_text;
      return this.getSum(item) % 2 === 0
        ? this.$t("reservation.double")
        : this.$t("reservation.single");
    },
    formatProfit(item) {
      if (Number(item.is_win) === 1) {
        return item.profit;
      }
      if (Number(item.is_win) === 2) {
        return item.profit;
      }
      return item.profit || item.win_text;
    },
    getUserGameList() {
      this.$http({
        method: "get",
        url: "user_get_game_list",
      }).then((res) => {
        if (res.code === 200) {
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserGameList();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-nav-bar .van-icon {
  color: #fff !important;
  font-size: 1.2rem;
}

::v-deep .van-nav-bar__title {
  color: #fff !important;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  height: 100%;
  padding: 0 12px 20px;
}

.record-card {
  margin: 14px 0;
  padding: 16px;
  border-radius: 18px;
  border: 1px solid #3f3f47;
  background: linear-gradient(
    180deg,
    rgba(35, 35, 43, 0.96),
    rgba(20, 20, 26, 0.96)
  );
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}

.record-title {
  min-width: 0;
}

.lottery-name {
  font-size: 34px;
  font-weight: 700;
  color: #fff;
  line-height: 1.3;
}

.period-number {
  margin-top: 4px;
  font-size: 24px;
  color: #9ea2b3;
  word-break: break-all;
}

.status-tag {
  flex-shrink: 0;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 22px;
  font-weight: 600;

  &.settled {
    color: #07c160;
    background: rgba(7, 193, 96, 0.14);
    border: 1px solid rgba(7, 193, 96, 0.35);
  }

  &.pending {
    color: #f7b84b;
    background: rgba(247, 184, 75, 0.14);
    border: 1px solid rgba(247, 184, 75, 0.35);
  }
}

.dice-panel {
  padding: 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.play-image-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.play-img {
  width: 76px;
  height: 76px;
  object-fit: contain;
}

.play-placeholder {
  min-width: 76px;
  min-height: 76px;
  padding: 0 12px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #f3d1a1;
  font-size: 22px;
  line-height: 1.4;
  background: rgba(244, 197, 125, 0.12);
  border: 1px solid rgba(244, 197, 125, 0.2);
}

.play-name {
  margin-top: 8px;
  font-size: 24px;
  color: #fff;
}

.result-tags {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}

.result-tag {
  min-width: 84px;
  padding: 6px 14px;
  border-radius: 999px;
  text-align: center;
  color: #f3d1a1;
  background: rgba(244, 197, 125, 0.12);
  border: 1px solid rgba(244, 197, 125, 0.2);
  font-size: 24px;
}

.meta-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.meta-item {
  padding: 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.meta-label {
  display: block;
  margin-bottom: 6px;
  font-size: 22px;
  color: #9599a8;
}

.meta-value {
  font-size: 28px;
  font-weight: 700;
  color: @white;
  word-break: break-word;
}

.meta-value.profit {
  color: #07c160;
}

.meta-value.loss {
  color: #ff6b6b;
}

.time-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-top: 10px;
  font-size: 22px;
}

.time-label {
  color: #9094a5;
}

.time-value {
  color: #fff;
  text-align: right;
  word-break: break-all;
}

@media (max-width: 420px) {
  .meta-grid {
    grid-template-columns: 1fr;
  }
}
</style>
